import React, { FormEvent, KeyboardEvent } from "react"
import styled from "styled-components"
import { DateFormatPreference, ISODate } from "../../formatters"
import { CommonPopperProps } from "./CommonPopperProps"
import { Popper } from "./Popper"
import { PopperSaveButton } from "./PopperSaveButton"
import { PopperDarkTheme, PopperLightTheme } from "./popperThemes"
import { DatePicker, DatePickerProps } from "../date-picker"
import { ThemeProvider } from "@mui/material/styles"

export type DatePickerPopperProps = Omit<DatePickerProps, "onChange" | "value"> &
  CommonPopperProps & {
    inputLabel?: string
    value?: ISODate
    dateFormatPreference?: DateFormatPreference
    onChange: (newDate: ISODate | undefined) => void
    onSubmit?: () => Promise<void> | void
  }

export const DatePickerPopper = (props: DatePickerPopperProps) => {
  const {
    popperTitle,
    inputLabel,
    value,
    dateFormatPreference = DateFormatPreference.DayMonthYear,
    onChange,
    onSubmit,
    onClose,
    onDelete,
    className,
    lightMode = false,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    dataCy,
    ...rest
  } = props

  const handleSubmit = (e: React.MouseEvent<Element, MouseEvent> | FormEvent) => {
    e.preventDefault()
    onSubmit && onSubmit()
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") handleSubmit(e)
  }

  return (
    <ThemeProvider theme={lightMode ? PopperLightTheme : PopperDarkTheme}>
      <Popper
        title={popperTitle}
        onClose={onClose}
        onDelete={onDelete}
        anchorEl={anchorEl}
        className={className}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <DatePickerContainer data-cy={dataCy}>
          <DatePicker
            fullWidth
            dateFormatPreference={dateFormatPreference}
            label={inputLabel}
            value={value}
            onChange={onChange}
            onKeyPress={handleKeyPress}
            inputDarkMode={!lightMode}
            {...rest}
          />
          <PopperSaveButton onClick={handleSubmit}>Save</PopperSaveButton>
        </DatePickerContainer>
      </Popper>
    </ThemeProvider>
  )
}

const DatePickerContainer = styled.div``
